import React from "react";
import type { Meta, StoryObj } from '@storybook/react';

import {Collapsible} from './Collapsible';

const meta: Meta<typeof Collapsible> = {
  title: 'Elements/Collapsible',
  component: Collapsible,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    title: {
      defaultValue: '',
      control: { type: 'text' }
    },
    openIcon:  {
      defaultValue: 'icon-alt-plus',
      control: { type: 'text' }
    },
    closeIcon:  {
      defaultValue: 'icon-alt-minus',
      control: { type: 'text' }
    },
    active:  {
      defaultValue: false,
      control: { type: 'boolean' }
    },
    disabled:  {
      defaultValue: false,
      control: { type: 'boolean' }
    },
    desktopDisabled:  {
      defaultValue: false,
      control: { type: 'boolean' }
    },
  },
};

export default meta;
type Story = StoryObj<typeof Collapsible>;

export const CollapsibleItem: Story = {
  args: {
    title: 'Collapsible Title',
    openIcon: 'icon-at-plus',
    closeIcon: 'icon-at-minus',
    active: false,
    disabled: false,
    desktopDisabled: false,
    children: (
      <div className="pb-4">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti ab repudiandae facere. Suscipit exercitationem ea cupiditate, blanditiis pariatur tempore laudantium consequuntur doloremque totam, labore voluptatibus quae? Explicabo, ipsa? Autem, sunt.
      </div>
    )
  },
};